type TargetRegistration={key:string;element:HTMLElement;reveal?:()=>void}
const registrations=new Set<TargetRegistration>()
export function registerGuideTarget(target:TargetRegistration){registrations.add(target);return()=>{registrations.delete(target)}}
const visible=(element:HTMLElement)=>{const style=getComputedStyle(element);return element.isConnected&&element.getClientRects().length>0&&style.visibility!=='hidden'&&style.display!=='none'&&!element.closest('[inert], [aria-hidden="true"]')}
/** A scrolled or covered target must never produce a highlight on unrelated UI. */
export function guideTargetRectangle(element:HTMLElement) {
  if(!visible(element))return null
  const bounds=element.getBoundingClientRect(),{left,top,width,height,right,bottom}=bounds
  if(width<=0||height<=0||left<0||top<0||right>innerWidth||bottom>innerHeight)return null
  const insetX=Math.min(8,width/4),insetY=Math.min(8,height/4)
  const points=[[left+insetX,top+insetY],[right-insetX,top+insetY],[left+insetX,bottom-insetY],[right-insetX,bottom-insetY],[left+width/2,top+height/2]]
  if(points.some(([x,y])=>{const hit=document.elementFromPoint(x,y);return !hit||!element.contains(hit)}))return null
  return {left,top,width,height}
}
export function findGuideTarget(key:string):HTMLElement|undefined {
  const aliases=[key,key.replace('planning.person-duty:','planning.pool-person-duty:'),key.replace('planning.person-hours:','planning.pool-person-hours:'),key.replace('stay.fulfill','stay.link')]
  for(const alias of aliases){
    const registered=[...registrations].find(item=>item.key===alias&&visible(item.element));if(registered)return registered.element
    const found=Array.from(document.querySelectorAll<HTMLElement>('[data-guide]')).find(element=>element.dataset.guide===alias&&visible(element));if(found)return found
    if(alias.startsWith('stay.')&&!alias.includes(':')){const matching=Array.from(document.querySelectorAll<HTMLElement>('[data-guide]')).filter(element=>element.dataset.guide?.startsWith(alias+':')&&visible(element));if(matching.length===1)return matching[0]}
  }
}
export function revealGuideTarget(key:string){
  // This read target exists in several panels. Reveal the canonical schedule summary
  // before lookup so a clipped resource-panel copy cannot trap the walkthrough.
  if(key==='planning.staffing'){
    window.dispatchEvent(new CustomEvent('luuta:guide-reveal',{detail:{key:'staffing'}}))
    return
  }
  if(findGuideTarget(key))return
  const registered=[...registrations].find(item=>item.key===key)
  if(registered?.reveal)registered.reveal()
  const workControl=key.startsWith('planning.work-select:')||key.startsWith('planning.work-source:')||['planning.territory','planning.access-filter','planning.work-search'].includes(key)
  const revealedKey=key.startsWith('planning.person-add:')?'people':workControl?'work':key.replace(/^planning\./,'')
  window.dispatchEvent(new CustomEvent('luuta:guide-reveal',{detail:{key:revealedKey}}))
}
